export function increment(n = 0) {
  return n + 1;
}

export function decrement(n = 0) {
  return n - 1;
}



// WEBPACK FOOTER //
// ./src/shared/redux/helpers/counter.js